import { ApiRetailerPaymentType, ApiTender, ApiTransaction } from '@vend/types'
import { IPromise, IScope } from 'angular'
import { VdEscapeStack } from 'vend.ui'
import { $q } from '../../../../ng-compat/imports'
import { Transaction } from './queries/Transaction'

interface SwiperPaymentModalOptions {
  retailerPaymentType: ApiRetailerPaymentType
  registerId: string
  amount: number
  currency: string
  paymentTypeId: number
}

export class SwiperPaymentModalController {
  public readonly close: (val?: IPromise<ApiTransaction>) => void
  public readonly registerId: string
  public readonly retailerPaymentType: ApiRetailerPaymentType
  public readonly amount: number
  public readonly currency: string
  public readonly closeModal: (transaction?: Transaction) => void
  private readonly internalClose: (val?: IPromise<ApiTransaction>) => void

  constructor(
    $scope: IScope,
    close: (val?: IPromise<ApiTransaction>) => void,
    public readonly options: SwiperPaymentModalOptions,
    private readonly vdEscapeStack: VdEscapeStack
  ) {
    'ngInject'

    this.internalClose = close
    this.closeModal = (transaction?: Transaction) => {
      if (transaction) {
        this.internalClose(
          Promise.resolve(
            this.convertTransactionToApiTransaction(transaction, options)
          )
        )
        return
      }
      this.internalClose()
    }
    this.close = this.internalClose

    this.registerId = options.registerId
    this.retailerPaymentType = options.retailerPaymentType
    this.amount = options.amount
    this.currency = options.currency

    $scope.$on('$destroy', () =>
      this.vdEscapeStack.deregister(() => this.internalClose($q.reject()))
    )
  }

  private convertTransactionToApiTransaction(
    transaction: Transaction,
    {
      registerId,
      retailerPaymentType,
      currency,
    }: {
      registerId: string
      retailerPaymentType: ApiRetailerPaymentType
      currency: string
    }
  ): ApiTransaction {
    return {
      id: transaction.id,
      retailer_payment_type_id: retailerPaymentType.id,
      register_id: registerId,
      register_sale_payment_id: transaction.registerSalePaymentID,
      payment_type_id: retailerPaymentType.type_id,
      status: transaction.status,
      provider_fields: null, // only provider_fields of tenders will be used for Swiper payment, so omitting transaction provider_fields
      tenders: transaction.tenders.map(
        (tender): ApiTender => ({
          id: tender.id,
          amount: tender.amount,
          status: tender.status,
          currency,
          emv: {
            tags: tender.emv.tags,
            aid: tender.emv.aid,
            application_label: tender.emv.applicationLabel,
            application_preferred_name: tender.emv.applicationPreferredName,
            cryptogram_type: tender.emv.cryptogramType,
            cryptogram: tender.emv.cryptogram,
            pin_statement: tender.emv.pinStatement,
          },
          type: tender.type,
          external_transaction_id: tender.externalTransactionID,
          card_details: {
            auth_code: tender.cardDetails.authCode,
            auth_result: tender.cardDetails.authResult,
            card: {
              brand: tender.cardDetails.card.brand,
              type: tender.cardDetails.card.type,
              last_four: tender.cardDetails.card.lastFour,
              fingerprint: tender.cardDetails.card.fingerPrint,
            },
            entry_method: tender.cardDetails.entryMethod,
          },
          provider_fields: tender.providerFields,
          created_at: tender.createdAt,
        })
      ),
    }
  }
}
